(function($, window) {
    this.roundSlider = function(slider, value, onDrag, onChange) {
        if (!value) {
            value = 0
        }
        $('#' + slider).roundSlider({
            circleShape: 'custom-quarter',
            width: 25,
            radius: 200,
            min: 0,
            max: 60,
            value: value,
            min: 0,
            max: 60,
            startAngle: 225,
            step: 0.1,
            editableTooltip: false,
            tooltipFormat: function(args) {
                var denta = args.value - 30
                if (denta - denta.toFixed(0) === 0) {
                    denta = denta
                } else {
                    denta = denta.toFixed(1)
                }
                // return args.value;
                return denta + '°'

            },
            drag: function(args) {
                console.log(args.value)
                onDrag(args.value)
            },
            change: function(args) {
                console.log(args.value)
                onChange(args.value)
            },
        })
    }
}(jQuery, window))



// WEBPACK FOOTER //
// src/assets/js/round-slider.js